<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item label="用户：" class="query-form-item">
                <el-input v-model="query.name" placeholder="请输入用户名|账号"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            class="mini_div"
            stripe border style="width: 100%">
            <el-table-column
                label="ID"
                prop="id"
                width="80px">
            </el-table-column>
            <el-table-column
                label="账号"
                prop="username">
            </el-table-column>
            <el-table-column
                label="用户名"
                prop="full_name">
            </el-table-column>

            <el-table-column
                label="操作"
                width="150"
                align="center"
                fixed="right">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click.native="assignTeamMembers(scope.$index, scope.row)">分配组员</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            background
            :page-size="query.limit"
            style="float: right;margin-top: 20px; margin-bottom: 22px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="query.page"
            :total="total">
        </el-pagination>
        <chooseDevelopModal ref="chooseDevelopModal"></chooseDevelopModal>

    </div>
</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import chooseDevelopModal from './chooseDevelopModal'

    export default {
        components: {chooseDevelopModal},
        data() {
            return {
                query: {
                    name: '',
                    page: 1,
                    limit: 20,
                },
                list: [],
                total: 0,
                loading: true,
            }
        },
        methods: {
            // 分配组员
            assignTeamMembers(index, data){
                this.$refs.chooseDevelopModal.openModal(data)
                console.log('--', index, data)
            },
            onReset() {
                this.query = {
                    name: '',
                    page: 1,
                    limit: 20,
                    total: 0
                }
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                api.group_manager_get_leader_list(this.query).then(res => {
                    if (res.code === 0) {
                        const responseList = res.data.list || []
                        this.list = responseList
                        this.query.total = res.data.total
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).finally(()=>{
                    this.loading = false
                })
            },
        },
        created() {
            this.getList()
        }
    }
</script>

<style type="text/scss" lang="scss">
    .mini_div .el-button--mini {
        padding: 5px 5px !important;
    }
</style>
